import { API } from '../axios-instance'
import { MediaObjectUrl } from '../media/types'

export enum LanguagesEnum {
  ENGLISH = 'en',
  SPANISH = 'es',
  FRENCH = 'fr',
  SIMPLIFIED_CHINESE = 'zh_CN',
  GERMAN = 'de',
}

export type TenantMetadata = {
  name: string
  language: LanguagesEnum
  logoUrls: MediaObjectUrl | null
  bannerUrls: MediaObjectUrl | null
  trialDaysRemaining: number | null
  tenantId: string | null
}

export const getTenantMetadata = async (domain: string) => {
  return await API.get<TenantMetadata>('/identity/tenants/metadata', {
    params: { domain },
  }).then(response => response.data)
}
